import { UserProfileApi } from "~/api/UserProfile";

export function useUserProfileApi(): UserProfileApi {
  const userProfileApi = new UserProfileApi(useHttpClient());

  return userProfileApi;
}
